export default __webpack_public_path__ + "static/media/hero.f8dea195.svg";